import React, { useEffect, useState } from "react";
import { SoundOutline, CloseOutline, MoreOutline, SetOutline } from 'antd-mobile-icons'
import { Button, Checkbox, Divider, Modal, Slider, Space, Tabs } from "antd-mobile";
import Cookies from "js-cookie";

import scanned from "../media/scanned.wav";
import short from "../media/short.wav";
import even from "../media/agree.wav";
import over from "../media/over.wav";
import not_found from "../media/notfound.wav";
import old from "../media/oldstock.wav";
import SoundSettings from "./SoundSettings";
import Spin from "./Spin";
import { drawError } from "../utils/utils";
import { apiCall } from "../utils/Api";


export default function Settings(props) {

    const [loading, setLoading] = useState(false)

    const logout = (_store_id = window.credentials.store_id) => {
        setLoading(true);
        apiCall("account/logout", { store_id: _store_id }, (_s, _r) => {
            if (_s) {
                Cookies.set("workstation", null,  { expires: 14 })
                window.location.reload();
            } else {
                drawError(_r.error);
            }
            setLoading(false);
        })
    }

    const changeLocation = () => {
        Cookies.set("workstation", null,  { expires: 14 })
        window.history.replaceState(null, '', '/');
        window.location.reload();
    }

    const changeStation = () => {
        Cookies.set("workstation", null,  { expires: 14 })
        window.location.reload();
    }

    const drawSettings = () => {

        const stores = window?.sitesettings?.available_corps?.filter(item => item.can_bmo) || [];

        return (
            <Spin loading={loading}>
                <Tabs>
                    <Tabs.Tab title='Sounds' key='sounds'>
                        <SoundSettings />
                    </Tabs.Tab>
                    <Tabs.Tab title='Account' key='settings'>
                        <div style={{ "textAlign": "left", "padding": "10px" }}>
                            <Button onClick={() => changeStation()} color="primary" block>Change Station #</Button>
                            <div className="shim" />
                            {(stores.length > 1 && 
                                 <Button onClick={() => changeLocation()} color="primary" block>Change Location</Button>
                            )}
                            {(stores.length > 1 && 
                                <div className="shim" />
                            )}
                            <Button onClick={() => logout()} color="primary" block>Logout</Button>
                        </div>
                    </Tabs.Tab>
                </Tabs>
            </Spin>
        )
    }


    const drawPopup = () => {
        const handler = Modal.show({
            title: <div>Settings <div style={{ "float": "right", "paddingRight": "10px" }} onClick={() => handler.close()}><CloseOutline /></div></div>,
            content: drawSettings(),
            closeOnMaskClick: true,
            actions: [],
        })
    }

    return (
        <>
            {/* <Modal content={drawSettings()} title="Sound Settings" closeOnMaskClick={true} onClose={() => setVisible(!visible)} visible={visible} /> */}
            <Button onClick={() => drawPopup()} fill='none'>
                <SetOutline style={{ "fontSize": "24px" }} />
            </Button>
        </>
    )
}